import styled from 'styled-components';

// Container for the entire layout (main content without the SideNav)
export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 100vh;
  background-color: transparent; /* Light pastel background */
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Align content towards the top */
  align-items: flex-start;
  flex: 1;
`;

// Heading style
export const Heading = styled.h1`
  font-size: 2.5rem;
  color: #333;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: left;
`;

// Paragraphs and lists
export const Description = styled.p`
  font-size: 1.2rem;
  color: #000;
  line-height: 1.8;
  max-width: 800px;
  margin-bottom: 30px;
`;

// Button style for "Start Game"
export const StartButton = styled.button`
  padding: 14px 28px;
  font-size: 18px;
  font-weight: 600;
  background-color: #007bff;
  color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);

  &:hover {
    background-color: #0056b3;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.3);
  }

  &:focus {
    outline: none;
  }
`;
